import { useEffect, useState } from 'react';
import { copyToClipboard } from '../services/utils';

export function useClipboard() {
  const [isCopied, setCopied] = useState(false);

  function copy(text: string) {
    if (isCopied === false) {
      const result = copyToClipboard(text);

      setCopied(result);
    }
  }

  useEffect(() => {
    if (isCopied) {
      setTimeout(() => {
        setCopied(false);
      }, 2000);
    }
  }, [isCopied]);

  return [isCopied, copy] as const;
}
